import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserService } from 'app/core/user/user.service';
import { FuseConfigService } from '@fuse/services/config';
import { User } from 'app/core/user/user.types';
import { IRole } from 'app/core/organisation/organisation.types';

@Component({
    selector: 'empty-layout',
    templateUrl: './empty.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [FuseLoadingBarComponent, RouterOutlet],
})
export class EmptyLayoutComponent implements OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    user: User;
    userRole: IRole;
    /**
     * Constructor
     */
        constructor(
        private _userService: UserService,
        private _fuseConfigService: FuseConfigService
    ) {
        combineLatest([
            
            this._userService.user$,
            this._userService.userRole$     
        ]).pipe(takeUntil(this._unsubscribeAll)).subscribe(([ user, userRole]) => {
            if (user) {
                this.userRole = userRole;
                this.user = user;
                //apply theme to fuse config from user preferences
                this._fuseConfigService.config = {
                    scheme: this.user.userPreferences?.find(preference => preference.key === 'theme')?.value as string
                };
            }
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
